import { render, staticRenderFns } from "./ArtworkDialogMulti.vue?vue&type=template&id=4a80e034&scoped=true"
import script from "./ArtworkDialogMulti.vue?vue&type=script&lang=js"
export * from "./ArtworkDialogMulti.vue?vue&type=script&lang=js"
import style0 from "./ArtworkDialogMulti.vue?vue&type=style&index=0&id=4a80e034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80e034",
  null
  
)

export default component.exports